const check = (
  accessPermissions,
  actions,
  condition = true,
  toggleOn = true
) => {
  if (!accessPermissions || !condition || !toggleOn) {
    return false;
  }
  //checking whether the actions have any of the permissions in the accessPermissions
  for (const action in actions) {
    if (accessPermissions.hasOwnProperty(actions[action])) return true;
  }
  return actions.length === 0;
};

const HasPermissionTo = ({
  permissions,
  perform,
  condition,
  toggleOn,
  render = () => null,
  noRender = () => null,
}) =>
  check(permissions, perform, condition, toggleOn) ? render() : noRender();

export default HasPermissionTo;
